module.exports = __webpack_public_path__ + "0381deb10b7da5cda6ad35912cf49b81.jpg";